import { eachDayOfInterval, subDays } from 'date-fns/fp';
var DAY_SLICING_SIZE = 364; // One year minus a day
/**
 * Generates date slices of maximum 364 days each from a given date range.
 * @param range The date range to slice
 * @param treatAsDateOnly Optional flag to indicate if dates should be treated as day-level precision (ignoring time).
 *                       When true, it will subtract one day to avoid overlapping days.
 *                       When false, it will use exact datetime precision.
 *                       Default is false for backward compatibility and precise datetime handling.
 * @returns Array of date range tuples [start, end]
 */
function generateLessThanOneYearDateSlices(range, treatAsDateOnly) {
    if (treatAsDateOnly === void 0) { treatAsDateOnly = false; }
    var originalDurationInDays = durationInTotalDays(range);
    if (originalDurationInDays <= DAY_SLICING_SIZE) {
        return [[new Date(range.start), new Date(range.end)]];
    }
    var calculatedRanges = [];
    var remainingDays = durationInTotalDays(range);
    var rangeClone = { start: new Date(range.start), end: new Date(range.end) };
    do {
        var endMinusDaysBack = subDays(DAY_SLICING_SIZE, rangeClone.end);
        calculatedRanges.push([endMinusDaysBack, rangeClone.end]);
        // If treating as date-only, subtract a day to avoid overlapping days
        // Otherwise, use the exact datetime as the new end
        rangeClone.end = treatAsDateOnly ? subDays(1, endMinusDaysBack) : endMinusDaysBack;
        remainingDays = durationInTotalDays(rangeClone);
    } while (remainingDays >= DAY_SLICING_SIZE);
    if (!treatAsDateOnly || remainingDays > 0) {
        calculatedRanges.push([rangeClone.start, rangeClone.end]);
    }
    return calculatedRanges;
}
/**
 * Returns the number of days in the interval inclusive of the start and end days.
 * So `durationInTotalDays({start: new Date(2014,9,6), end: new Date(2014,9,10)})`
 * counts both 2014-09-06 and 2014-09-10 for a total of 5 days.
 * @param interval
 */
function durationInTotalDays(interval) {
    if (interval.start > interval.end) {
        var reverseInterval = { start: interval.end, end: interval.start };
        return -1 * eachDayOfInterval(reverseInterval).length;
    }
    return eachDayOfInterval(interval).length;
}
export { generateLessThanOneYearDateSlices };
